import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'

const LEGACY_WRAPPER = 'legacy'

const FIELD_NAME = {FROM: 'from', TO: 'to'}

export default function FormPriceWithTabs({
  initialSearch = {},
  onChange = () => {},
  overlayContentRef,
  type,
  wrapper = LEGACY_WRAPPER
}) {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {instalmentAmounts, prices, FILTER_NAMES} = config.get('search')

  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {DEFAULT_FILTERS_SEARCH} = config.get('searchFilters')
  const isInstalmentFilter = initialSearch[FILTER_NAMES.HAS_INSTALMENT]

  const handleChange = ({name, value}) => {
    const [currentValue] = value

    onChange(null, {
      field: name,
      value: {
        [FIELD_NAME.FROM]: null,
        [FIELD_NAME.TO]: currentValue === allSelectionsId ? DEFAULT_FILTERS_SEARCH[name].to : Number(currentValue)
      },
      lastFilter: TRACKING_FILTER_NAMES[name][FIELD_NAME.TO.toUpperCase()]
    })
  }

  const handleReset = ({filters}) => {
    const [filterName] = filters
    onChange(null, {
      field: filterName,
      value: DEFAULT_FILTERS_SEARCH[filterName]
    })
  }

  const localizePriceValue = value => ({
    id: value,
    label: i18n.c(value)
  })
  const priceOptions = prices.map(localizePriceValue)
  const instalmentOptions = instalmentAmounts.map(localizePriceValue)

  const getPlaceholder = value => {
    const {hasInstalment, instalment, price} = initialSearch
    if (
      (instalment?.to === value && value !== null) ||
      (hasInstalment && instalment?.to !== null && price?.to === null)
    )
      return `${i18n.t('COMMON.MONTHLY_FEE', {
        amount: i18n.c(value)
      })}`

    if ((price?.to === value && value !== null) || (!hasInstalment && instalment?.to === null && price?.to !== null))
      return i18n.c(value)

    return i18n.t('COMMON.PRICE')
  }

  const currentValue = isInstalmentFilter ? initialSearch[FILTER_NAMES.INSTALMENT] : initialSearch[FILTER_NAMES.PRICE]

  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON_TO'),
          label: i18n.t('COMMON_CASH'),
          name: FILTER_NAMES.PRICE,
          options: priceOptions,
          type
        },
        {
          allSelectionsLabel: i18n.t('COMMON_TO'),
          label: i18n.t('COMMON.FEE'),
          name: FILTER_NAMES.INSTALMENT,
          options: instalmentOptions,
          type
        }
      ]}
      group={`${FILTER_NAMES.PRICE}Group`}
      legend={i18n.t('COMMON.PRICE')}
      onChange={handleChange}
      onReset={handleReset}
      overlayContentRef={overlayContentRef}
      placeholder={getPlaceholder(currentValue?.to || null)}
      value={{
        [FILTER_NAMES.PRICE]: [initialSearch[FILTER_NAMES.PRICE].to || allSelectionsId],
        [FILTER_NAMES.INSTALMENT]: [initialSearch[FILTER_NAMES.INSTALMENT].to || allSelectionsId]
      }}
      wrapper={wrapper}
    />
  )
}

FormPriceWithTabs.displayName = 'FormPriceWithTabs'
FormPriceWithTabs.propTypes = {
  initialSearch: PropTypes.object,
  onChange: PropTypes.func,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  wrapper: PropTypes.string
}
